import { useEffect, useState } from 'react';

export function useAnimatedMount(isVisible: boolean, delay = 300) {
    const [shouldRender, setShouldRender] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (isVisible) {
            setShouldRender(true);
            requestAnimationFrame(() => setIsActive(true));
        } else {
            setIsActive(false);
            const timeout = setTimeout(() => setShouldRender(false), delay);
            return () => clearTimeout(timeout);
        }
    }, [isVisible, delay]);

    return [shouldRender, isActive];
}
